(function()
{
 	var app = angular.module("app");

 	app.run(["functions", function(functions)
 	{
 		// functions.loading();
 	}]);

 	app.controller('SearchController', ['$scope', '$rootScope', '$http', "functions", function($scope, $rootScope, $http, functions)
	{
		$rootScope.filters 			= [];
		$rootScope.radius_index 	= $rootScope.distances.length-1;
		$rootScope.scale_min 		= 0;
		$rootScope.scale_max 		= 9999;
		$rootScope.transportation 	= 0;
		$scope.keywords 			= "";
		$scope.title 				= "";
		$scope.timeout 				= null;
		$scope.ignore_it			= false;

		$scope.map_organizations = function()
		{
			return $scope.organizations;
		}

		$rootScope.searchTimeout = function()
		{
			// Clear any previous calls to this function.
			clearTimeout($scope.timeout);

			// Cancel any HTTP request currently still in progress.
			if($rootScope.http_worker != null)
			{
				$rootScope.http_worker.resolve();
			}

			// Trigger a search in 1 second.  This gives the user a chance to whack multiple inputs before a search happens.
          	// $scope.timeout = setTimeout(function() { $scope.search() }, 1000);
		}

        $scope.search = function()
        {
        	if($scope.keywords == "")
        	{
        		return;
        	}

        	// Cancel any HTTP request currently still in progress.
			if($rootScope.http_worker != null)
			{
				$rootScope.http_worker.resolve();
			}

        	functions.loading();
        	var data = 	{
							'offset': 			0,
							'limit': 			10000,
							'keywords': 		$scope.keywords,	//.replace(/[.!@#$%^&*()<>\[\]{}?=~`|\\\/;:]/g, "")
							'radius': 			($rootScope.radius_index == ($rootScope.distances.length-1) ? 1000000 : $rootScope.radius),
							'latitude': 		$rootScope.latitude,
							'longitude':		$rootScope.longitude,
							'unit':				$rootScope.unit,
							'scale_min':		$rootScope.scale_min,
							'scale_max':		$rootScope.scale_max,
							'transportation':	$rootScope.transportation,
							'filters': 			JSON.stringify($rootScope.filters),
							'type': 			(window.location.href.indexOf("/tag/") !== -1 ? "tag" : "query"),
							'ignore_it': 		($scope.ignore_it ? "1" : "0")
						};

			// Only count the topic search stuff once per page load.
			$scope.ignore_it = true;

			$http(
		    {
		    	method: 'POST',
  			    url: '/search/results',
  			    data: jQuery.param(data),
  			    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
  			    timeout: $rootScope.http_worker
  			}).
			success(function(data, status, headers, config)
			{
				$scope.topics 			= data["topics"];
				$scope.organizations 	= data["organizations"];

				functions.loaded();
			}).
			error(function(data, status, headers, config)
			{
				error("Error Loading Search Results", data, true, null);
				functions.loaded();
			});
		}

		$scope.selectTopic = function(event, topic)
		{
			window.location = "/" + topic.location_seo_name + "/" + topic.seo_name;
		}

        $rootScope.$watch
		(
			function(scope)
			{
				return $rootScope.reload_search;
			},
          	function(newValue, oldValue)
          	{
          		if(newValue == true)
          		{
          			$rootScope.reload_search = false;
	          		$scope.searchTimeout();
	          	}
          	}
        );

		$scope.$watch
		(
			function(scope)
			{
				return $scope.keywords;
			},
          	function(newValue, oldValue)
          	{
          		if(newValue == oldValue) { return; }

          		// $scope.keywords = decodeURIComponent($scope.keywords);
          		$scope.searchTimeout();
          	}
        );

		jQuery(document).ready(function()
		{
			$scope.search();
		});
	}]);
})();
